function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
_toConsumableArray(document.querySelectorAll('.js-call-to-action')).forEach(function (block) {
  var heading = block.querySelector('.js-call-to-action__heading');
  var glossary = block.querySelector('.js-call-to-action__glossary');
  var element = null;
  var left = 0;

  // Grab all the words from the heading
  var headingWords = heading.innerText.split(' ');

  // Remove all the words from the heading
  heading.innerHTML = '';

  // We wanna have lots of words as this is gonna be a slider
  var _loop = function _loop() {
    // grab all the words from the glossary
    var glossaryWords = glossary.innerHTML.split(' ');

    // Loop through the heading words
    headingWords.forEach(function (word) {
      // Each word needs to be wrapped in a span
      var span = document.createElement('span');
      // If the word is in the glossary, add the glossary class
      if (glossaryWords.indexOf(word) > -1) {
        span.className = 'inherit-colour';
        // remove the word from the glossary
        glossaryWords.splice(glossaryWords.indexOf(word), 1);
      }
      ;
      // Add the word to the span
      span.innerText = word;
      // Add the span to the heading
      heading.appendChild(span);
    });
  };
  for (var i = 0; i < 5; i++) {
    _loop();
  }

  // Grab the first element
  element = heading.firstElementChild;
  var update = function update() {
    requestAnimationFrame(update);
    left -= 1;
    heading.style.transform = "translateX(".concat(left, "px)");
    if (left <= -element.clientWidth) {
      left = 0;
      heading.style.transform = "translateX(".concat(left, "px)");
      heading.removeChild(element);
      heading.appendChild(element);
      element = heading.firstElementChild;
    }
  };
  update();
});